import { render, staticRenderFns } from "./StandardPDF.vue?vue&type=template&id=5bb62544&scoped=true"
import script from "./StandardPDF.vue?vue&type=script&lang=js"
export * from "./StandardPDF.vue?vue&type=script&lang=js"
import style0 from "./StandardPDF.vue?vue&type=style&index=0&id=5bb62544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb62544",
  null
  
)

export default component.exports